import axiosClient from "utils";

async function fetchPlayer(params, options) {
  const url = `/v1/members`;
  return axiosClient.get(url, { params, ...options });
}

export { fetchPlayer };
